import React from 'react';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';

const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// iter332 — service identity under a warranty payer, matching the main Invoices page.
export const JobForLine = ({ r }) => (r.job_for_name
  ? <div data-testid={`office-row-jobfor-${r.id}`} className="text-[10px] text-[#A3A3A3]">Job for: <span className="text-[#D4D4D4]">{r.job_for_name}</span></div> : null);

export const LinkedToggle = ({ r, open, onToggle }) => (r.linked_count > 1 ? (
  <button type="button" data-testid={`office-row-linked-${r.id}`} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onToggle(); }}
    className="mt-0.5 inline-flex items-center gap-1 text-[10px] text-[#A3A3A3] hover:text-[#D4AF37]">
    <Link2 className="w-3 h-3" />{r.linked_count} linked invoices{open ? ' ▴' : ' ▾'}
  </button>) : null);

// Context only: each invoice stays its own record; the row's Review still opens r.href.
export const RelatedBilling = ({ r }) => (
  <div data-testid={`office-related-${r.id}`} className="rounded-md border border-[#262626] bg-[#0A0A0A] px-3 py-2 space-y-1" onClick={(e) => e.stopPropagation()}>
    <p className="text-[10px] uppercase tracking-wider text-[#737373]">Related Billing</p>
    {r.related_billing.map((b) => (
      <Link key={b.id} to={b.href} data-testid={`office-related-item-${r.id}-${b.id}`}
        className={`flex items-center justify-between gap-3 text-xs hover:text-[#D4AF37] ${b.is_this ? 'text-white font-semibold' : 'text-[#D4D4D4]'}`}>
        <span className="truncate">{b.payer} — {money(b.amount)} — {b.status_label}</span>
        <span className="text-[10px] text-[#737373] shrink-0">{b.is_this ? 'this invoice' : (b.payor_kind === 'warranty' ? 'HSP / warranty' : 'customer')}</span>
      </Link>
    ))}
  </div>
);
